export type OAuthProviders = 'Google' | 'Apple';
export type LoginProvider = OAuthProviders | 'email';

export type Gender = 'Male' | 'Female' | 'Non-binary';
export const genders: Gender[] = ['Male', 'Female', 'Non-binary'];

export type Language =
  | 'English'
  | 'Español'
  | '中文'
  | 'Русский'
  | '日本語'
  | 'Bahasa Indonesia'
  | 'Português'
  | 'Français';

export const languages: Language[] = [
  'English', // English
  'Español', // Spanish
  '中文', // Chinese
  'Русский', // Russian
  '日本語', // Japanese
  'Bahasa Indonesia', // Indonesian
  'Português', // Portuguese
  'Français', // French
];

export type Platform = 'google' | 'apple' | 'cognito';

export type UserState = {
  email: string;
  password?: string; // GET 응답에 없음
  name: string;
  nickname: string;
  language: string;
  gender: string | null;
  birth_date: string;
  privacy_agree: boolean;
  avatar_agree: boolean;
  marketing_agree: boolean;
  timezone_iana: string;
  platform?: Platform; // GET 응답에 없음
};
interface setUsertate {
  email?: string;
  password?: string;
  name?: string;
  nickname?: string;
  birth_date?: string;
  gender?: string | null;
  privacy_agree?: boolean;
  avatar_agree?: boolean;
  marketing_agree?: boolean;
  language?: UserState['language'];
}

export interface UserActions {
  setUser: (state: setUsertate) => void;
  resetUserData: () => void;
}

export type UserStore = UserState & UserActions;
